import React from 'react';
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getAPI } from '../GdacsAPI';

const ServiceRow = (props) => {
    const [service, setService] = React.useState(props.service.id);
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [regions, setRegions] = React.useState([]);
    const [servicestypesdevice, setServicesTypesDevice] = React.useState([]);
    const [alertLevel, setAlertLevel] = React.useState(["Red", "Orange", "Green"]);
    const [language, setLanguage] = React.useState([]);
    const [eventtypes, setEventTypes] = React.useState([]);

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
            setServicesTypesDevice(servicesTypesData);
            setLanguage(servicesTypesData[1].listLanguages);
        }
    }

    async function GetRegions() {
        var url = getAPI() + `api/register/Definition/regions/`;
        const response = await fetch(url);
        if (!response.ok) {
            setRegions('Failed to retreive regions data.');
            return;
        }
        const regionsData = await response.json();
        if (regionsData) {
            setRegions(regionsData);
        }
    }

    async function GetEventTypes() {
        var url = getAPI() + `api/register/Definition/eventtypes/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEventTypes('Failed to retreive event types data.');
            return;
        }
        const eventtypesData = await response.json();
        if (eventtypesData) {
            setEventTypes(eventtypesData);
        }
    }


    React.useEffect(() => {
        GetServicesTypes();
        GetRegions();
        GetEventTypes();
    }, []);

    React.useEffect(() => {
        if (service.idServiceType === undefined && servicestypes.length > 0)
            setService((a) => ({ ...a, idServiceType: servicestypes[0].idServiceType }));
    }, [servicestypes]);

    return (
        <tr>
            <td className="cell_hidden">{props.service.id}</td>
            <td className="cell_hidden">{props.service.idService}</td>
            <td className="cell_alerts" style={{ textAlign: "center" }}>
                <img src={`Images/${props.service.eventType}_Blue.png`} className="icon_table" />
            </td>
            {servicestypes.filter(item => item.idServiceType === props.service.idServiceType).map(types => (
                <td className="cell_alerts" key={types.idServiceType} style={{ textAlign: "center" }}>
                    {types.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />
                    }
                </td>
            ))}
            <td className="cell_alerts" key={props.service.alertLevel} style={{ textAlign: "center" }}><img src={`Images/${props.service.alertLevel}-bullet.gif`} /> </td>
            {
                regions.filter(item => item.idRegion === props.service.region).map(reg => (
                    <td className="cell_alerts" key={reg.idregion}>{reg.regionName}</td>
                ))}
            {
                language.filter(item => item.key === props.service.language).map(lang => (
                    <td className="cell_alerts" key={lang.language}>{lang.value}</td>
                ))
            }
            <td className="cell_alerts"><input className="input-checkbox" type='checkbox' defaultChecked={props.service.stopNight} disabled /></td>
            <td className="cell_alerts"><input className="input-checkbox" type='checkbox' defaultChecked={props.service.enabled} disabled /></td>
            <td>
                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "#ed7d31" }} onClick={() => props.onRequestEditService(props.service.id)} ><FaIcons.FaRegEdit style={{ height: '20px' }} /></button> &nbsp;
                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "#ed7d31" }} onClick={() => props.onRequestDeleteService(props.service.id)}><FaIcons.FaRegTrashAlt style={{ height: '20px' }} /></button>
            </td>
        </tr>
    )
}

export { ServiceRow };